import * as React from 'react'
import { AspectRatio, Container } from '@chakra-ui/react'

export const VideoBlock = (props: { title: string; video: string }) => {
  return (
    <Container maxWidth='6xl'>
      <AspectRatio ratio={16 / 9}>
        <iframe src={props.video}></iframe>
      </AspectRatio>
    </Container>
  )
}
